import { render, staticRenderFns } from "./goVip.vue?vue&type=template&id=8b100802&scoped=true&"
import script from "./goVip.vue?vue&type=script&lang=js&"
export * from "./goVip.vue?vue&type=script&lang=js&"
import style0 from "./goVip.vue?vue&type=style&index=0&id=8b100802&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b100802",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b100802')) {
      api.createRecord('8b100802', component.options)
    } else {
      api.reload('8b100802', component.options)
    }
    module.hot.accept("./goVip.vue?vue&type=template&id=8b100802&scoped=true&", function () {
      api.rerender('8b100802', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/goVip.vue"
export default component.exports